import ACS from "./ACS";
import ADF from "./ADF";
import AFC from "./AFC";
import AltC from "./AltC";
import AS from "./AS";
import DP from "./DP";
import EES from "./EES";
import EnlDesp from "./EnlDesp";
import IBF from "./IBF";
import NGV from "./NGV";
import PS from "./PS";
import TMT from "./TMT";
import TMM from "./TMM";
import TTC from "./TTC";
import VCC from "./VCC";
import ARSUB from "./ARSUB";
import IPSP from "./IPSP";
import ADO from "./ADO";
import ADC from "./ADC";
import PC from "./PC";
import ADH from "./ADH";
import ADN from "./ADN";
import AVL from "./AVL";
import TAH from "./TAH";
import Perdas from "./Perdas";
import Piso from "./Piso";
import PDT from "./PDT";
import TTP from "./TTP";
import Falhas from "./Falhas";
import UQL from "./UQL";
import LC from "./LC"
import LBM from "./LBM"
import CM from "./CM"
import MM from "./MM"
import BA from "./BA"
import PCorte from "./PCorte"
import Bio from "./Bio"
import Perf from "./Perf"
import AH from "./AH"
import PragaSolo from "./PragaSolo";
import DC from "./DC";
import DCor from "./DCor";
import AC from "./AC";
import MMAnual from "./MManual";
import ABA from "./ABA";
import IMV from "./IMV";
import PSM from "./PSM";
import PEsc from "./PEsc";
import PerdM from "./PerdM";
import Torr from "./Torr";
import TC from "./TC";

// Deve estar num arquivo separado para evitar imports cíclicos.
// Estão na ordem que irão aparecer nas listagens e configurações.
const all = [
    ABA,
    AC,
    ACS,
    ADC,
    ADF,
    ADH,
    ADN,
    ADO,
    AFC,
    AH,
    AltC,
    ARSUB,
    AS,
    AVL,
    BA,
    Bio,
    CM,
    DC,
    DCor,
    DP,
    EES,
    EnlDesp,
    Falhas,
    IBF,
    IMV,
    IPSP,
    LBM,
    LC,
    MM,
    MMAnual,
    NGV,
    PC,
    PCorte,
    PEsc,
    PDT,
    Perdas,
    PerdM,
    Perf,
    Piso,
    PragaSolo,
    PS,
    TAH,
    TC,
    TMM,
    TMT,
    Torr,
    TTC,
    TTP,
    UQL,
    VCC,
    PSM
]

/**
 * Todos os indicadores existentes.
 */
export function getAllIndicadores() {
    return all;
}


/**
 * Todos os indicadores que são somente manual
 */
export function getIndicadoresManual() {
    return [Falhas, LC, Perf, LBM, PCorte, PerdM, PragaSolo, PSM, MMAnual]
}


/**
 * Todos os indicadores que são somente mecanizado
 */
export function getIndicadoresMecanizado() {
    return [ACS, ADH, ADN, AFC, AH, ARSUB, AS, EnlDesp, IBF, IPSP, PC, PEsc, Perdas, Piso, TAH, TMT, TMM, Torr, TTC, UQL, DC, DCor, AC]
}


/**
 * Todos os indicadores que podem ser manual ou mecanizado
 */
export function getIndicadoresManualMecanizado() {
    return [NGV, ADF, EES, VCC, PS, AltC, ADC, PDT, TTP, BA, AVL, MM, ADO, CM, DP, TC]
}


/**
 * Retorna a classe do indicador correspondente ao nome do campo.
 */
export function getIndicadorByField(field) {
    for (const IndicadorClass of all) {
        if (IndicadorClass.field === field) {
            return IndicadorClass;
        }
    }
}
